import {GeneralService} from "../../../../../services/generalService";
import {RouteService} from "../../../../../services/routeService";
import {NotificationService} from "../../../../../services/notificationService";
import {DICTIONARY} from "../../../../../dictionary";
import util from "util";
import {Component, OnInit} from "@angular/core";
import _ from "lodash";

@Component({
	selector: 'outbound-policies-component',
	templateUrl: './outbound-policies.component.html',
})
export class OutboundPoliciesComponent implements OnInit {
    constructor(public gs: GeneralService,
				private rs: RouteService,
				private ns: NotificationService) {
    }

    dic = DICTIONARY;
    userPolicy;
    allowedAuthMethods;
	blockFileTypes;
    getPoliciesDataInProcess;
	notifyOptionsPopup: any;

	releaseRequestSubjectDesc = 'Dynamic fields like {{SENDER_EMAIL}}, {{EMAIL_SUBJECT}} and {{COMPANY_NAME}} can be used to show information about the email.\n' +
		'If this field is left empty, the default Trustifi subject will be used.';
	releaseRequestSubjectPlaceholder = '({{COMPANY_NAME}}) {{SENDER_EMAIL}} release request for email "{{EMAIL_SUBJECT}}"';
	retentionType;
	blockInappropriateContentMode: any;
	planUsers: any;
	updatePolicyInProcess: boolean;

	ngOnInit() {
        this.getPoliciesDataInProcess = true;

        this.rs.getRulesAndPolicy().then((response) => {
			if (!response.plan?.isReviewerAllowedRules) {
				this.ns.showErrorMessage('You do not have access to review this page');
				this.getPoliciesDataInProcess = false;
				return
			}

            this.userPolicy = response.plan.policy;
			this.userPolicy.malicious_outbound = {enabled: true};

			this.userPolicy.retentionValue = this.userPolicy.retention.value;
            this.userPolicy.retentionType = this.userPolicy.retention.type;

            this.allowedAuthMethods = _.map(this.dic.CONSTANTS.secureMethods, method => {
                return {
                    name: method,
                    selected: this.userPolicy.allowed_auth_methods.includes(method)
                }
            });

			this.blockFileTypes = _.map(['Macros', 'Scripts', 'Executables'], method => {
				return {
					name: method,
					selected: this.userPolicy.block_emails_by_attachment_types?.includes(method)
				}
			});

			this.getPlanUsers();
            this.getPoliciesDataInProcess = false;
        }, (err) => {
			this.getPoliciesDataInProcess = false;
		});
    }


	getPlanUsers = () => {
		this.blockInappropriateContentMode = this.userPolicy.block_inappropriate_content.enabled ?
			this.dic.CONSTANTS.groupSelection.all : this.dic.CONSTANTS.groupSelection.disabled;

		this.rs.getUsersOfSharedPlan({onlyUsersAndSubAdmins: true}).then((users) => {
			this.planUsers = users;
			if (this.userPolicy.block_inappropriate_content.exclude_users?.length) {
				this.userPolicy.block_inappropriate_content.exclude_users.forEach((email) => {
					const userObj = this.planUsers.find(itm => itm.email === email);
					if (userObj) {
						userObj.selected = true;
					}
				});
			}
		}, (err) => {

		});
	}

    updatePolicy(policyKey, policyValue) {
		switch (policyKey) {
			case 'expired_days':
			case 'delete_attachment_days':
				if (policyValue.value < 1 || policyValue.value > 365) {
					this.ns.showErrorMessage(this.dic.ERRORS.expiredInputInvalid);
					return;
				}
				break;
		}

		this.updatePolicyInProcess = true;
        this.rs.updatePolicy({action: this.dic.CONSTANTS.updatePolicyActions.policy, data: {key: policyKey, val: policyValue}}).then(() => {
			this.updatePolicyInProcess = false;
		}, () => {
			this.updatePolicyInProcess = false;
		});
    };

	handlePolicyEmailRecallMaxTimeChange() {
		const actionInfo = {
			action: this.dic.CONSTANTS.updatePolicyActions.emailRecallMaxTime,
			data: {max_hours: this.userPolicy.allow_recall_email.max_hours}
		};

		this.updatePolicyInProcess = true;
		this.rs.updatePolicy(actionInfo).then(() => {
			this.updatePolicyInProcess = false;
		}, () => {
			this.updatePolicyInProcess = false;
		});
	};


	updateRetention() {
        if (!this.userPolicy.retentionValue) return;

        if (this.userPolicy.retention.enabled) {
            if (this.userPolicy.retentionValue < 1) {
                return this.ns.showErrorMessage(util.format(this.dic.ERRORS.retentionValuesInvalid, this.userPolicy.retentionType, this.dic.CONSTANTS.retentionMaxDays[this.userPolicy.retentionType]));
            }

            let isErr = false;

            switch (this.userPolicy.retentionType) {
                case this.dic.CONSTANTS.timePeriod.day:
                    if (this.userPolicy.retentionValue > this.dic.CONSTANTS.retentionMaxDays.day) {
                        isErr = true;
                    }
                    break;

                case this.dic.CONSTANTS.timePeriod.month:
                    if (this.userPolicy.retentionValue > this.dic.CONSTANTS.retentionMaxDays.month) {
                        isErr = true;
                    }
                    break;

                case this.dic.CONSTANTS.timePeriod.year:
                    if (this.userPolicy.retentionValue > this.dic.CONSTANTS.retentionMaxDays.year) {
                        isErr = true;
                    }
                    break;
            }
            if (isErr) {
                return this.ns.showErrorMessage(util.format(this.dic.ERRORS.retentionValuesInvalid, this.userPolicy.retentionType, this.dic.CONSTANTS.retentionMaxDays[this.userPolicy.retentionType]));
            }

			this.userPolicy.retention.value = this.userPolicy.retentionValue;
			this.userPolicy.retention.type = this.userPolicy.retentionType;

			this.gs.showPopup({
				title: 'Update Retention Policy',
				subTitle: `You are about to set your retention policy to ${this.userPolicy.retentionValue} ${this.userPolicy.retentionType}s`,
				body: ['After the selected time period, all emails and attachments will be permanently deleted from Trustifi'],
				type: this.dic.CONSTANTS.popupWarning,
				doneBtnText: 'Confirm',
				doneCb: () => {
					this.updatePolicyInProcess = true;
					this.rs.updatePolicy({
						action: this.dic.CONSTANTS.updatePolicyActions.retention,
						data: this.userPolicy.retention
					}).then(() => {
						this.updatePolicyInProcess = false;
					});
				}
			});
        }
		else {
			this.updatePolicyInProcess = true;
			this.rs.updatePolicy({
				action: this.dic.CONSTANTS.updatePolicyActions.retention,
				data: this.userPolicy.retention
			}).then(() => {
				this.updatePolicyInProcess = false;
			});
		}
    };

    updateAuthMethods() {
        this.userPolicy.allowed_auth_methods = _.map(_.filter(this.allowedAuthMethods, 'selected'), 'name');
        if (!this.userPolicy.allowed_auth_methods.length) {
            return this.ns.showErrorMessage(this.dic.ERRORS.atLeastOneAuthMethod);
        }

		this.updatePolicyInProcess = true;
        this.rs.updatePolicy({action: this.dic.CONSTANTS.updatePolicyActions.authenticationMethods, data: {allowed_auth_methods: this.userPolicy.allowed_auth_methods}}).then(() => {
			this.updatePolicyInProcess = false;
		}, () => {
			this.updatePolicyInProcess = false;
		});
    };

	updateAttachmentEncryptPolicy() {
		if (this.userPolicy.attachment_encryption.threshold > 5 || this.userPolicy.attachment_encryption.threshold < 1) {
			this.ns.showErrorMessage(DICTIONARY.ERRORS.attachmentsScoreValues);
			return;
		}

		const actionInfo = {
			action: this.dic.CONSTANTS.updatePolicyActions.attachmentEncryption,
			data: {
				type: this.userPolicy.attachment_encryption.value,
				threshold: this.userPolicy.attachment_encryption.threshold
			}
		};

		this.updatePolicyInProcess = true;
		this.rs.updatePolicy(actionInfo).then(() => {
			this.updatePolicyInProcess = false;
		}, () => {
			this.updatePolicyInProcess = false;
		});
	};

	updateBlockFileTypes() {
		this.userPolicy.block_emails_by_attachment_types = _.map(_.filter(this.blockFileTypes, 'selected'), 'name');

		this.updatePolicyInProcess = true;
		this.rs.updatePolicy({action: this.dic.CONSTANTS.updatePolicyActions.blockFileTypes, data: {block_emails_by_attachment_types: this.userPolicy.block_emails_by_attachment_types}}).then(() => {
			this.updatePolicyInProcess = false;
		}, () => {
			this.updatePolicyInProcess = false;
		});
	};

    updateInappropriateContentCategory() {
		const data = {
			enabled: this.blockInappropriateContentMode === this.dic.CONSTANTS.groupSelection.all,
			exclude_users: this.planUsers.filter(itm => itm.selected).map(itm => itm.email),
		};

        const updateData = {
            action: this.dic.CONSTANTS.updatePolicyActions.inappropriateContentCategory,
            data: {block_inappropriate_content: data}
        };

		this.updatePolicyInProcess = true;
        this.rs.updatePolicy(updateData).then(() => {
			this.updatePolicyInProcess = false;
		}, () => {
			this.updatePolicyInProcess = false;
		});
    };

	openNotifyOptionsPopup() {
		this.notifyOptionsPopup = {
			show: true,
			emails: this.userPolicy.notify_sender_outbound_quarantined.notify_email_for_release_request,
			notifyAllowRequestSubject: this.userPolicy.notify_sender_outbound_quarantined.notify_release_request_subject
		};
	};

    updatePolicyOutboundQuarantinedSenderNotify() {
		if (this.notifyOptionsPopup) {
			if (this.notifyOptionsPopup.emails && !_.every(this.notifyOptionsPopup.emails.split(','), email => this.gs.validateEmail(email.trim())) ) {
				this.ns.showWarnMessage(this.dic.ERRORS.oneOfEmailsInvalid);
				return;
			}
			this.userPolicy.notify_sender_outbound_quarantined.notify_email_for_release_request = this.notifyOptionsPopup.emails ? this.notifyOptionsPopup.emails.replace(/ /g, '') : '';
			this.userPolicy.notify_sender_outbound_quarantined.notify_release_request_subject = this.notifyOptionsPopup.notifyAllowRequestSubject;
		}
        const updateData = {
            action: this.dic.CONSTANTS.updatePolicyActions.outboundQuarantinedSenderNotify,
            data: {
				notify_sender_outbound_quarantined: this.userPolicy.notify_sender_outbound_quarantined
            }
        };
        this.rs.updatePolicy(updateData).then(() => {
			this.notifyOptionsPopup = null
		});
    };

	handleKeydown(event: KeyboardEvent): boolean {
		const blockedKeyCodes = [69, 109, 189, 187, 190];
		if (blockedKeyCodes.includes(event.keyCode)) {
			event.preventDefault();
			return false;
		}
		return true;
	}

	protected readonly _ = _;
}
